import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export const container = (theme: Theme) => css`
  display: grid;
  position: relative;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;
  grid-auto-flow: row;
  grid-gap: ${theme.spacing[16]};
  align-content: end;
  justify-items: center;
  width: 100%;
`
